import {
  IStorageNodeProviderFind,
  IStorageNodeProviderListItem,
  StorageNodeProviderSortField,
} from "api/entities/storage-node-providers";
import {
  CREDENTIALS_INFO,
  DELETE_BLOCKED_CONFIRMATION_DIALOG_NAME,
  DELETE_CONFIRMATION_DIALOG_NAME,
  STORAGE_PROVIDER_ENTITY_NAME,
} from "redux/actions/storage-provider";
import { IDialogState } from ".";
import { IDeleteBlockedConfirmationData } from "components/shard-repositories/dialogs/delete-blocked-confirmation/delete-blocked-confirmation";
import { IShardRepositoryCredentialsConfirmationData } from "api/entities/shard-repository";
import { createDialogReducer, DIALOG_DEFAULT_STATE } from "./dialog";
import {
  createEntityReducer,
  getEntityDefaultState,
  IEntityState,
} from "./entity";
import { SortDirection } from "api/entities/page";
import { AnyAction } from "redux";

export interface IStorageProviderState
  extends IEntityState<
    IStorageNodeProviderListItem,
    StorageNodeProviderSortField,
    IStorageNodeProviderFind
  > {
  [DELETE_CONFIRMATION_DIALOG_NAME]: IDialogState<IStorageNodeProviderListItem>;
  [DELETE_BLOCKED_CONFIRMATION_DIALOG_NAME]: IDialogState<IDeleteBlockedConfirmationData>;
  [CREDENTIALS_INFO]: IDialogState<IShardRepositoryCredentialsConfirmationData>;
}

function getStorageProviderDefaultState(
  sortField: string
): IStorageProviderState {
  return {
    [DELETE_CONFIRMATION_DIALOG_NAME]: DIALOG_DEFAULT_STATE,
    [DELETE_BLOCKED_CONFIRMATION_DIALOG_NAME]: DIALOG_DEFAULT_STATE,
    [CREDENTIALS_INFO]: DIALOG_DEFAULT_STATE,
    ...getEntityDefaultState(sortField, SortDirection.Ascending),
  };
}

const entityReducer = createEntityReducer(STORAGE_PROVIDER_ENTITY_NAME);
const deleteConfirmationReducer = createDialogReducer(
  STORAGE_PROVIDER_ENTITY_NAME,
  DELETE_CONFIRMATION_DIALOG_NAME
);
const deleteBlockedConfirmationReducer = createDialogReducer(
  STORAGE_PROVIDER_ENTITY_NAME,
  DELETE_BLOCKED_CONFIRMATION_DIALOG_NAME
);
const excessiveCredentialsConfirmationReducer = createDialogReducer(
  STORAGE_PROVIDER_ENTITY_NAME,
  CREDENTIALS_INFO
);

export function storageProvider(
  state: IStorageProviderState = getStorageProviderDefaultState(
    StorageNodeProviderSortField.Name
  ),
  action: AnyAction
): IStorageProviderState {
  state = entityReducer(state, action);
  state = deleteConfirmationReducer(state, action);
  state = deleteBlockedConfirmationReducer(state, action);
  state = excessiveCredentialsConfirmationReducer(state, action);
  return state;
}
